import { connect } from 'react-redux';
import compose from 'lodash/flowRight';

import tripsActions from '../../../actions/trip';

import TripEditor from './TripEditor';

const mapStateToProps = state => ({
  editing: state.trip.editing,
  creating: state.trip.creating,
  error: state.trip.error,
});

const mapDispatchToProps = dispatch => ({
  editTrip: compose(dispatch, tripsActions.editTrip),
  createTrip: compose(dispatch, tripsActions.createTrip),
});

export default connect(mapStateToProps, mapDispatchToProps)(TripEditor);
